var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"second-banner"},_vm._l((_vm.secbanner),function(item,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0)]),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc02625","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/solutionDetail/solutionDetail.vue
// module id = null
// module chunks = 